import { InfoComponent } from '../../../pages/modules/PortfolioSummary/PortfolioSummary';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';

export const RestrictedInfoComponent = () => {
  return (
    <Tooltip
    placement="top"
    arrow
    TransitionComponent={Zoom}
    style={{ float: 'right' }}
    title={
      <p>
        <strong>Updates are restricted as this Core SPID is either allocated to someone already, or exists in Priority Cleansing or Managed Service.</strong>
      </p>
    }>
      <InfoComponent />
    </Tooltip>
  )
}